import { theme } from "../../theme.js";

export default function LargeItemCard({children, onClick, justify = false}) {
    return (
    <>
    {justify ? (
      <div style={styles(theme).ItemJustify} onClick={onClick}>
          {children}
      </div>)
    :
      (<div style={styles(theme).Item} onClick={onClick}>
          {children}
      </div>)
     }
    </>
    );
}

const styles = (theme) => ({
    Item: {
    display: "flex",
    gap: theme.spacing.lg,
    padding: theme.spacing.md,
    backgroundColor: theme.colors.bgLight,
    borderRadius: theme.radius.md,
    alignItems: "center",
    flex : "1 1 100%",
    minHeight: "79px",
    border: `1px solid ${theme.colors.border}`,
  },
  
    ItemJustify: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing.md,
    backgroundColor: theme.colors.bgLight,
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.border}`,    
    flex : "1 1 100%",
  },
});
